module.exports = __webpack_public_path__ + "img/security-net.b793f75e.svg";